.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-2);
  width: 100%;
  padding: var(--sp-8) var(--sp-6);
  border: 1.5px dashed var(--line2);
  border-radius: var(--radius-lg);
  background: var(--surf2);
  color: var(--text2);
  font-size: 11.5px;
  text-align: center;
  cursor: pointer;
  transition: var(--transition);
}
.dropzone:hover:not(:disabled),
.dragging {
  border-color: var(--magenta);
  background: var(--surf3);
  color: var(--text);
}
.dropzone:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.hint {
  font-size: 10px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  margin-top: var(--sp-4);
}
.row {
  display: flex;
  gap: var(--sp-4);
  align-items: center;
  padding: var(--sp-3) var(--sp-4);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: var(--surf2);
}
.icon {
  font-size: 15px;
}
.info {
  flex: 1;
  min-width: 0;
}
.name {
  overflow: hidden;
  font-size: 11.5px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.status {
  margin: 2px 0 var(--sp-1);
  color: var(--text2);
  font-size: 10px;
}
.failed {
  color: var(--magenta);
}
.empty {
  color: var(--text2);
  font-size: 11px;
}
